import * as React from 'react';

export default class NotFound extends React.Component {
  render() {
    return <h1>Page not found</h1>;
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/not_found/index.jsx